/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-game-difficulty-slider-popover.vue?vue&type=template&id=58224ec9&scoped=true&"
import script from "./edit-game-difficulty-slider-popover.vue?vue&type=script&lang=js&"
export * from "./edit-game-difficulty-slider-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58224ec9",
  null
  
)

export default component.exports